import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getGroupCount,
  getNewAddGroup,
  getNewAddRecord,
  getNewAddUser,
  getUserCount,
  getRedEnvelopeAmount,
  getTransferMoneyAmount
} from "@/api/modules/todayData";

// 用户数量
export const getUserCountAction = createAsyncThunk(
  "todayData/getUserCount",
  async () => {
    // getUserChannels函数是一个axios的请求
    const result = await getUserCount();
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

// 群组数量
export const getGroupCountAction = createAsyncThunk(
  "todayData/getGroupCount",
  async () => {
    // getUserChannels函数是一个axios的请求
    const result = await getGroupCount();
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

// 新增用户
export const getNewAddUserAction = createAsyncThunk(
  "todayData/getNewAddUser",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await getNewAddUser(params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);
// 新增群组
export const getNewAddGroupAction = createAsyncThunk(
  "todayData/getNewAddGroup",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await getNewAddGroup(params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);
// 登录记录
export const getNewAddRecordAction = createAsyncThunk(
  "todayData/getNewAddRecord",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await getNewAddRecord(params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);


export const getRedEnvelopeAmountAction = createAsyncThunk(
  "todayData/getRedEnvelopeAmount",
  async () => {
    const result = await getRedEnvelopeAmount();
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
)

export const getTransferMoneyAmountAction = createAsyncThunk(
  "todayData/getTransferMoneyAmount",
  async () => {
    const result = await getTransferMoneyAmount();
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
)